// extracted by mini-css-extract-plugin
var _1 = "PricingModalTierLabel-module__animatedBackground--I0oNG";
var _2 = "PricingModalTierLabel-module__tierLabel--Sdawv";
var _3 = "PricingModalTierLabel-module__tierLabelPrice--U3jVJ";
var _4 = "PricingModalTierLabel-module__tierLabelTitle--E5Jov";
var _5 = "PricingModalTierLabel-module__tierLabelUser--JBwTg";
export { _1 as "animatedBackground", _2 as "tierLabel", _3 as "tierLabelPrice", _4 as "tierLabelTitle", _5 as "tierLabelUser" }
